export default __webpack_public_path__ + "static/kargul-6328b80ad3ba2210e557a51a3db430fc.jpg";